<template>
  <b-container v-loading="isBusy" class="py-4">
    <b-row>
      <b-col>
        <BaseHeader>
          <router-link
            :to="{ name: 'FCPLogList' }"
            class="btn btn-primary btn-icon-only p-0 mr-4 rounded-circle"
          >
            <i class="fa fa-arrow-left"></i>
          </router-link>

          <h2 class="header-title m-0">{{ route.params.fileName }}</h2>
        </BaseHeader>

        <div class="previewer-container">
          <div ref="previewRef"></div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import 'jspreadsheet-ce/dist/jspreadsheet.css'

import { defineComponent, ref, onMounted } from '@vue/composition-api'
import { useRoute } from 'vue2-helpers/vue-router'
import jspreadsheet from 'jspreadsheet-ce'

import { BaseHeader } from '@/components/base'
import { FCPUpload } from '@services'

export default defineComponent({
  name: 'FCPLogPreview',
  components: {
    BaseHeader
  },
  setup() {
    const route = useRoute()

    const previewRef = ref()
    const isBusy = ref(true)

    const fetchPreview = async () => {
      isBusy.value = true

      const {
        data: {
          data: {
            data: { xl_sheets }
          }
        }
      } = await FCPUpload.readFCPUpload(
        route.params.uniqueId,
        route.params.fileName
      ).finally(() => (isBusy.value = false))

      jspreadsheet(previewRef.value, {
        columns: xl_sheets[0].data[0].map((item) => ({
          type: 'text',
          title: item,
          width: '150px'
        })),
        data: xl_sheets[0].data.slice(1),
        allowToolbar: true
      })
    }

    onMounted(fetchPreview)

    return {
      route,
      previewRef,
      isBusy
    }
  }
})
</script>

<style scoped>
.previewer-container {
  max-height: 700px;
  overflow-x: auto;
}
</style>
